<template>
    <div class="list-header">
        <slot></slot>
    </div>
</template>
<style scoped>
.list-header {
    border: 1px solid #eff0f1;
    margin-bottom: 20px;
    padding: 12px 10px;
    background: #f3f4f5;
    border-radius: 4px;
}
</style>
<script>
export default {
    name: 'ListHeader'
}
</script>
